export default "__VITE_ASSET__Cqgvp_Yw__"